module.exports = __webpack_public_path__ + "static/img/icon4.cca97f72.png";